module.exports = __webpack_public_path__ + "img/clubicon-microphone.ac53c0f2.png";